import { useState } from "react";
import { ArrowRight, LockKeyhole } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function LoginPage() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [submitting, setSubmitting] = useState(false);
  const submit = async (event) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    setSubmitting(true);
    try {
      const user = await signIn(form.get("email"), form.get("password"));
      toast.success(`Welcome back, ${user.name}.`);
      const defaultDestination = user.role === "candidate" ? "/candidate-portal" : "/admin";
      const requestedDestination = location.state?.from;
      const canUseRequestedDestination =
        (user.role === "candidate" && requestedDestination === "/candidate-portal") ||
        (user.role !== "candidate" && requestedDestination === "/admin");
      const destination = canUseRequestedDestination ? requestedDestination : defaultDestination;
      navigate(destination, { replace: true });
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <main className="auth-page" data-testid="login-page">
      <section className="auth-aside">
        <p className="eyebrow light-eyebrow">RIGHT HIRE PERSONNEL</p>
        <h1>SECURE<br />ACCESS TO<br /><span>THE WORK.</span></h1>
        <p>Recruiters and registered workers can sign in to manage profiles, documents and recruitment activity.</p>
      </section>
      <section className="auth-panel">
        <div className="auth-panel-inner">
          <LockKeyhole size={28} data-testid="login-lock-icon" />
          <p className="eyebrow">SIGN IN</p>
          <h2>WELCOME BACK.</h2>
          <form onSubmit={submit} data-testid="login-form">
            <label className="field-wrap">Email<input name="email" type="email" className="field-input" required data-testid="login-email-input" /></label>
            <label className="field-wrap">Password<input name="password" type="password" className="field-input" required data-testid="login-password-input" /></label>
            <button type="submit" className="button-primary form-submit" disabled={submitting} data-testid="login-submit-button">
              {submitting ? "Signing in…" : "Sign in securely"}
              <ArrowRight size={17} />
            </button>
          </form>
        </div>
      </section>
    </main>
  );
}